import { Link } from "@/components/common/Link";
import { cn } from "@/lib/utils";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function VerneLegacy() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="leredità-vernè" className="relative w-full py-24 overflow-hidden bg-secondary">
      {}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none select-none" aria-hidden="true">
        <span className="text-[12rem] sm:text-[20rem] md:text-[30rem] font-bold text-primary/5 leading-none tracking-tighter">
          50
        </span>
      </div>

      {}
      <div ref={ref} className={cn("relative z-10 container mx-auto px-6 max-w-3xl text-center transition-all duration-1000 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10")}>
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-primary mb-6 tracking-tight">
          L'Eredità Vernè
        </h2>

        <p className="text-lg md:text-xl text-muted-foreground mb-10 leading-relaxed font-light">
          Da oltre 50 anni, la famiglia Vernè è sinonimo di eccellenza nella
          progettazione e realizzazione di serramenti. Una storia fatta di
          passione, artigianalità italiana e innovazione continua che trasforma
          ogni spazio in un ambiente unico.
        </p>

        <Link to="/AboutUsPage" className="inline-flex items-center text-primary font-medium text-lg hover:text-primary/80 transition-colors group">
          <span className="border-b border-primary/30 group-hover:border-primary transition-all duration-300 pb-1">
            Scopri la nostra storia
          </span>
        </Link>
      </div>
    </section>;
}